import { useEffect } from 'react';

const SITE = 'https://fullrun.io';

// Per-route title, description and canonical. index.html carries the
// homepage's values and a boot-time canonical rewrite; this keeps them right
// after client-side navigation.
export default function usePageMeta({ title, description, path, noindex = false }) {
  useEffect(() => {
    // Signed-in surfaces (Runs) carry noindex; the sitemap never lists them.
    let robots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) { robots = document.createElement('meta'); robots.setAttribute('name', 'robots'); document.head.appendChild(robots); }
      robots.setAttribute('content', 'noindex, nofollow');
    } else if (robots && robots.getAttribute('content') === 'noindex, nofollow') {
      robots.remove();
    }
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement('meta'); m.setAttribute('name', 'description'); document.head.appendChild(m); }
      m.setAttribute('content', description);
    }
    const canon = document.querySelector('link[rel="canonical"]');
    if (canon) canon.setAttribute('href', SITE + (path || window.location.pathname).replace(/\/+$/, '') || SITE + '/');
  }, [title, description, path, noindex]);
}
